import { computed, toValue } from 'vue'
import type { ComputedRef, MaybeRefOrGetter } from 'vue'

import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'

export function usePolicyLinkEditPermission(
  resourceType: MaybeRefOrGetter<AuthorizationResourcesAndSubjects | undefined>
): { canEditPolicyLinks: ComputedRef<boolean> } {
  const permissionsStore = usePermissionsStore()

  const canEditPolicyLinks = computed(() => {
    switch (toValue(resourceType)) {
      case AuthorizationResourcesAndSubjects.Schedule:
        return permissionsStore.checkAnyRessources({
          permission: AuthorizationPermissions.SchedulePolicyLinksEditing,
          resourceType: AuthorizationResourcesAndSubjects.Schedule
        })
      case AuthorizationResourcesAndSubjects.HealthUnit:
        return permissionsStore.checkAnyRessources({
          permission: AuthorizationPermissions.HealthUnitPolicyLinksEditing,
          resourceType: AuthorizationResourcesAndSubjects.HealthUnit
        })
      case AuthorizationResourcesAndSubjects.Company:
        return permissionsStore.checkAnyRessources({
          permission: AuthorizationPermissions.CompanyPolicyLinksEditingGranted,
          resourceType: AuthorizationResourcesAndSubjects.Company
        })
      default:
        return false
    }
  })

  return { canEditPolicyLinks }
}
